<template>
	<vs-navbar class="vx-navbar navbar-skelton mb-base" type="fund">
		<div slot="title">
			<vs-navbar-title>
				<div class="flex flex-row justify-start items-center">
					<transition name="fade">
						<vx-tooltip delay=".1s" :text="$t('DesignConfig.ChangeName')">
							<vs-button
								size="large"
								v-show="selected.id > 0"
								@click="handleOption('CHANGE_NAME')"
								icon-pack="feather"
								icon="icon-edit"
								color="dark"
								type="flat"
								radius
							></vs-button>
						</vx-tooltip>
					</transition>
					<span v-show="selected" class="ml-2">{{ selected.name }}</span>
				</div>
			</vs-navbar-title>
		</div>

		<vx-tooltip delay=".1s" :text="$t('Add') + ' ' + $t('DesignConfig.Property')">
			<vs-button
				size="large"
				@click="handleOption('ADD_PROPERTY')"
				icon-pack="feather"
				icon="icon-plus-square"
				color="dark"
				type="flat"
				radius
			></vs-button>
		</vx-tooltip>

		<transition name="fade">
			<vx-tooltip delay=".1s" :text="$t('Save')">
				<vs-button
					size="large"
					v-show="selected"
					@click="handleOption('SAVE')"
					icon-pack="feather"
					icon="icon-save"
					color="dark"
					type="flat"
					radius
					:disabled="selected.name.trim().length <= 0"
				></vs-button>
			</vx-tooltip>
		</transition>

		<transition name="fade">
			<vx-tooltip delay=".1s" :text="$t('Cancel')">
				<vs-button
					size="large"
					v-show="selected"
					@click="handleOption('CANCEL')"
					icon-pack="feather"
					icon="icon-x-square"
					color="danger"
					type="flat"
					radius
				></vs-button>
			</vx-tooltip>
		</transition>
	</vs-navbar>
</template>

<script>
export default {
	props: {
		handleOption: {
			type: Function,
			required: true,
		},
		selected: {
			type: Object,
			default: null,
		},
		typeConfigurationName: {
			type: String,
			default: "",
		},
	},
	data() {
		return {};
	},
	methods: {
		goToConfig() {
			this.$router
				.push({
					name: "app-setting",
					params: {config_type: "LIST"},
				})
				.catch(() => {});
		},
	},
};
</script>
